import React, { useState, useEffect, useContext } from "react";
import "./App.css";
import "./style.scss";
import Web3 from "web3";
import Header from "./components/Header";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import StakingMain from "./components/Staking/StakingMain";
import Projects from "./components/Projects";
import CreateSale from "./components/IDO/CreateSale";
import Projectsdetail from "./components/Projects-detail";
import ClosedProjectDetail from "./components/ClosedProjects/ClosedProjectdetail";
import { AppContext } from "./utils";
import { UseSalesContract } from "./ConnectivityAss/hooks";
import Footer from "./components/Footer";

const web3 = new Web3(
  Web3.givenProvider || "https://bsc-dataseed.binance.org/"
);
function App() {
  const { account, connect, signer } = useContext(AppContext);
  const salesContract = UseSalesContract(signer);
  const [ownerAdd, setownerAdd] = useState();
  const [user, setuser] = useState("");
  useEffect(() => {
    if (!account) {
      connect();
    }
  }, [account]);

  const init = async () => {
    try {
      const owner = await salesContract.admin();
      let addressOwner = owner.toLowerCase();
      setownerAdd(addressOwner);
      let add = account.toLowerCase();
      setuser(add);
    } catch (error) {}
  };
  useEffect(() => {
    init();
  }, [salesContract, account]);
  return (
    <>
      <BrowserRouter>
        <Header />
        <Routes>
          <Route exact path="/" element={<Projects />} />
          <Route path="/staking" element={<StakingMain />} />
          <Route path="/projects" element={<Projects />} />
          {/* {user == ownerAdd ? ( */}
          <Route path="/ido" element={<CreateSale />} />
          {/* ) : null} */}
          <Route path="/projectdetails/:id" element={<Projectsdetail />} />
          <Route
            path="/closed-projects/:id"
            element={<ClosedProjectDetail />}
          />
        </Routes>
        <Footer />
      </BrowserRouter>
    </>
  );
}

export default App;
